"use client";
import React, { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import Link from "next/link";
import CommonButton from "@/components/CommonButton";

import {
  FaCode,
  FaLaptopCode,
  FaMobileAlt,
  FaCloud,
  FaCog,
  FaRocket,
  FaClock,
} from "react-icons/fa";

export default function Custom404() {
  const router = useRouter();
  const [countdown, setCountdown] = useState(10);

  // Update countdown every second
  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => Math.max(prev - 1, 0));
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  // Redirect once countdown reaches 0
  useEffect(() => {
    if (countdown === 0) {
      router.push("/");
    }
  }, [countdown, router]);

  return (
    <div className="error-container">
      <div className="floating-icons">
        <div className="floating-icon">
          <FaCode />
        </div>
        <div className="floating-icon">
          <FaLaptopCode />
        </div>
        <div className="floating-icon">
          <FaMobileAlt />
        </div>
        <div className="floating-icon">
          <FaCloud />
        </div>
        <div className="floating-icon">
          <FaCog />
        </div>
        <div className="floating-icon">
          <FaRocket />
        </div>
      </div>

      <div className="container error-content">
        <div className="row justify-content-center align-items-center min-vh-100">
          <div className="col-lg-8 text-center">
            <div className="error-number">404</div>
            <h1 className="error-title">Oops! Page Not Found</h1>
            <p className="error-subtitle">
              The page you&apos;re looking for seems to have vanished into the
              digital void. Don&apos;t worry, even the best developers encounter 404s
              sometimes!
            </p>

            <div className="mt-4 d-flex justify-content-center align-items-center gap-3">
              <Link href="/" role="button" aria-label="Back to Home">
                <CommonButton label="Back to Home" className="btn-primary" />
              </Link>
              <Link href="/contact" aria-label="View contact page">
                <CommonButton
                  label="Contact us"
                  variant="outline"
                  className="white-border"
                />
              </Link>
            </div>

            <div className="countdown-badge">
              <FaClock className="me-2" />
              Auto-redirecting to home in {countdown} seconds
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
